import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2vdjeb6mau: FaireBrandEntity = {
  token: "b_2vdjeb6mau",
  type: "brand",
  name: "Graza",
  avatarUrl:
    "https://cdn.faire.com/fastly/2320932e2f27b1a666a91b91ef04e162da69c982c7b76a531b128a03b19c7c1e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0fd25bcd695d6144a7df67cf3b8bc7e0df6141192f8b7307b256d00a1753ce93.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2320932e2f27b1a666a91b91ef04e162da69c982c7b76a531b128a03b19c7c1e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0fd25bcd695d6144a7df67cf3b8bc7e0df6141192f8b7307b256d00a1753ce93.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 111,
  isInsider: true,
  description:
    "Every kitchen deserves good, fresh olive oil that’s affordable enough to be used every day. Our single origin oils do just that, and they come in a squeezy bottle that makes everything easier and more fun.\n\nMost olive oil in the U.S. is blended from old, low quality oils. But across the ocean, people are using fresh, never-blended olive oil by the gallon. Graza is that olive oil. We're made from 100% Picual olives from Jaen, Spain, the region where over half the world’s olive oil is produced.\n\nAs pretty as our farms are, at the end of the day we’re here because of our love for cooking and our firm belief that everything tastes better when there's olive oil involved. ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:44.451Z",
    importedBy: "entity-db-cli",
  },
};
